import React from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import { usePermissions } from "layouts/Admin";
// import { ViewQuotationModal } from "views/Translation/ViewQuotationModal";
import FullPageLoader from "components/common/FullPageLoader";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import TranslationViewTable from "views/Translation/TranslationViewTable";
import { getInterpreterTranslationById } from "slices/interpreter/interpreterTranslationSlice";
import InterpreterTransLogsTable from "./InterpreterTransLogsTable";
import UploadDocument from "components/appointment/UploadDocument";
import toast from "react-hot-toast";
// import { translationUploadDocument } from "slices/interpreter/inviteInterpreterTranslatorsSlice";
import CancelModal from "components/appointment/CancelModal";
// import SelectTranslatorModal from "components/common/SelectTranslatorModal";
import { assignTranslators } from "slices/interpreter/inviteInterpreterTranslatorsSlice";
import { translationCancel } from "slices/interpreter/inviteInterpreterTranslatorsSlice";
import { interpreterTranslationUploadDocument } from "slices/interpreter/inviteInterpreterTranslatorsSlice";
import { interpreterDeclineTranslation } from "slices/interpreter/inviteInterpreterTranslatorsSlice";
import TranslatedDocumentsTable from "./TranslatedDocumentsTable";
import InterpreterTranslationViewTable from "./InterpreterTranslationViewTable";

const TranslationView = () => {
  const { id } = useParams();
  const { checkPermission } = usePermissions();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [assignTranslator, setAssignTranslator] = React.useState(false);
  const [uploadDocumentTranslator, setUploadDocumentTranslator] =
    React.useState(false);
  const [cancelTranslator, setCancelTranslator] = React.useState(false);
  const [quotationView, setQuotationView] = React.useState({
    show: false,
    id: null,
  });

  const callViewApi = async () => {
    const callBack = (success, data) => {
      setLoading(false);
      if (success) {
        setItem(data);
      } else {
        setItem({});
      }
    };
    dispatch(getInterpreterTranslationById(id, callBack));
  };

  React.useEffect(() => {
    if (id) {
      setLoading(true);
      callViewApi();
    }
  }, [id]);

  const mileageCheck = (val) => {
    return item?.appointment_details?.[val];
  };

  const rawDatetime = item?.created_at;
  const formattedDate = moment(rawDatetime, "YYYY-MM-DD HH:mm:ss").format(
    "MMM D, YYYY HH:mm:ss"
  );

  const handleCloseAssignTranslator = () => {
    setAssignTranslator(false);
  };

  const handleCloseCancelTranslator = () => {
    setCancelTranslator(false);
  };

  const handleCloseUploadDocumentTranslator = () => {
    setUploadDocumentTranslator(false);
  };

  const handleCancelTranslator = () => {
    setCancelTranslator(true);
  };

  const handleUploadDocumentTranslator = () => {
    setUploadDocumentTranslator(true);
  };

  const onAssign = (iterp_id) => {
    const payload = {
      interpreter_id: iterp_id,
    };
    const callBack = (success) => {
      if (success) {
        toast.success("Assigned Successfully", {
          className: "successToast",
        });
        callViewApi();
        handleCloseAssignTranslator();
      } else {
      }
    };
    dispatch(assignTranslators(payload, id, callBack));
  };

  // Decline Translation
  const onDeclineTranslation = (data) => {
    setLoading(true);
    const callBack = (success) => {
      if (success) {
        toast.success("Cancelled Successfully", {
          className: "successToast",
        });
        setLoading(false);
        callViewApi();
        handleCloseCancelTranslator();
      } else {
      }
    };
    dispatch(interpreterDeclineTranslation(data, id, callBack));
  };

  // Upload Translation Document
  const onUploadDocument = (data) => {
    setLoading(true);
    const callBack = (success) => {
      if (success) {
        toast.success("Uploaded Successfully", {
          className: "successToast",
        });
        setLoading(false);
        callViewApi();
        handleCloseUploadDocumentTranslator();
      } else {
      }
    };
    const formdata = new FormData();
    formdata.append("file", data);
    dispatch(interpreterTranslationUploadDocument(formdata, id, callBack));
  };

  const statusMap = {
    "Translators Invited": "Invited",
    "Invoice Sent": "Submission Approved",
    "Client Cancelled": "Cancelled",
    "Quote Sent": "Quote Received",
  };

  return (
    <div className="content" style={{}}>
      {/* {quotationView.show && (
        <ViewQuotationModal
          itemId={quotationView?.id}
          item={item}
          show={quotationView.show}
          onClose={() => setQuotationView({ show: false, id: null })}
        />
      )} */}

      {/* <SelectTranslatorModal
        isOpen={assignTranslator}
        onClose={handleCloseAssignTranslator}
        onConfirm={onAssign}
        appointmentId={id}
        item={item}
        loader={loading}
      /> */}

      <CancelModal
        isOpen={cancelTranslator}
        onClose={handleCloseCancelTranslator}
        onConfirm={onDeclineTranslation}
        appointmentId={id}
        item={item}
        loader={loading}
        heading="Translation"
        showAppId={false}
      />

      <UploadDocument
        isOpen={uploadDocumentTranslator}
        onClose={handleCloseUploadDocumentTranslator}
        onConfirm={onUploadDocument}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      {loading && <FullPageLoader />}
      <div className="row_main_head bg-primary-secondaryCard">
        <h2 className={`main_heading main_heading1 mb-3`}>
          translation job #{item?.transid}
        </h2>
        <h2 className={`main_heading main_heading1 mb-3`}>
          Client : #{item?.accounts?.user?.name || "N/A"}
        </h2>
      </div>
      <div className="row_main_head bg-light-secondaryCard mt-3">
        <h2 className={`main_heading2`} toLowerCase={"text-lowercase"}>
          Date & Time <span className="dateTime">{formattedDate}</span>
        </h2>

        <div className="mb-3 row_check">
          <div className="text-transform-capitalize main_heading2">
            <span className="appLanguage">
              {" "}
              {statusMap[item.status] || item.status}
            </span>
          </div>
        </div>
      </div>

      <div className="card_table view_table_custom">
        <div className="row-primary flex-wrap">
          {item?.status !== "Completed" &&
            item?.status !== "Translator Declined" &&
            item?.status !== "Invoice Sent" && (
              <SubmitButton
                buttonType="button"
                className={"tomatoRed"}
                btnText="Decline Translation"
                handleSubmit={handleCancelTranslator}
              />
            )}
          {(item.status == "Assigned" ||
            item.status == "Submission Rejected") && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="Upload Translated Documents"
                handleSubmit={handleUploadDocumentTranslator}
              />
            )}
        </div>

        {mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == null ? (
          <div className="row_main_head align-items-center softAlert waiting">
            <h3>The vendor has requested extra mileage</h3>
            {checkPermission("Extra Mileage") && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="View Request"
              />
            )}
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 1 ? (
          <div className="softAlert approved">
            <h3>
              The extra mileage request for this appointment have been approved.
            </h3>
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 0 ? (
          <div className="softAlert rejected">
            <h3>
              The extra mileage request for this appointment have been rejected.
            </h3>
          </div>
        ) : (
          ""
        )}

        {/* <TranslationViewTable item={item} /> */}
        <InterpreterTranslationViewTable item={item} />
      </div>

      {item && item?.translation_translated_files?.length > 0 && (
        <>
          <div className="card_table p-4">
            <div className="row_main_head mb-3">
              <h2 className={`main_heading`}>Translated Documents</h2>
            </div>
            <TranslatedDocumentsTable item={item} callViewApi={callViewApi} />
          </div>
        </>
      )}
      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Original Documents</h2>
        </div>
        <InterpreterTransLogsTable item={item} />
      </div>

      {/* <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Translation Logs</h2>
        </div>
        <LogsTable logs={logs} />
      </div> */}

      {/* <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Quotations History</h2>
        </div>
        <QuotationsTable item={item} onApprove={onApprove} onReject={onReject} onView={openQuotationView} />
      </div> */}
    </div>
  );
};

export default TranslationView;
